import { createI18n } from "vue-i18n";

const messages = {
  en: {
    user_list_button_new_user: "New User",
    user_list_page_bread: "Users",
    user_list_page_bread_title: "Users List",
    customer_detail_button_edit: "Edit Detail",
    customer_detail_label_company_detail: "Company Detail",
    customer_detail_label_adress: "Address",
    customer_detail_label_country: "Country",
    customer_detail_label_email: "Email",
    customer_detail_label_contact_phone: "Contact Phone",
    customer_detail_label_personel: "Official Personnel",
    customer_detail_label_name: "Customer Name",
    customer_detail_label: "Customer",
    location_list_breadcrumb_title: "Locations List",
    location_list_column_status: "STATUS",
    location_list_column_country: "COUNTRY",
    location_list_column_customer: "CUSTOMER",
    location_list_column_code: "CODE",
    location_list_column_name: "NAME",
    location_list_add_button: "New Location",
    location_modal_check_label: "Active",
    location_modal_check_label_description: "Is the location system status active?",
    location_modal_select_statu: "Select location type",
    location_modal_label_select_status: "Location Type",
    location_modal_select_oparation_type: "Select Oparation type",
    location_modal_customer_placeholder: "Select Customer",
    location_modal_name: "Location Name",
    location_modal_code: "Location Code",
    location_user: "User Location",
    location_modal_validation_name: "Location name is required",
    location_modal_validation_customer: "Customer selection is required",
    NewLocation: "New Location",
    Locations: "Locations",
    ActivitiyTypeNew: "New Operation",
    ActivitiyTypeUpdateTitle: "Operation Update",
    ActivitiyTypeAddTitle: "Add New Operation",
    PhoneNumber_UC: "PHONE",
    EMail_UC: "E-MAIL",
    Official: "Official",
    Official_UC: "OFFICIAL",
    Country: "Country",
    Country_UC: "COUNTRY",
    Delete_Select: "Delete Selection",
    Records_Found: "Record Found",
    ActivitiyTypeAdd_5: "OPERATION NAME",
    ActivitiyTypeAdd_4: "Operation Name",
    ActivitiyTypeAdd_3: "Business Operation Type",
    ActivitiyTypeAdd_2: "Contents",
    ActivitiyTypeAdd_1: "Creating an Business Operation",
    ActivitiyTypeAdd_Business_Activity_Type_Page: "Operation List",
    ActivitiyTypeAdd_Valid_Name: "Operation name is required",
    customer_modal_check_label: "Active",
    customer_modal_check_label_description: "Is the customer system status active?",
    CustomersAdd_New: "New Customer",
    Customers: "Customers",
    CustomerAdd_CustomerIdentificationPage: "Customers List",
    CustomerAdd_Valid_CompanyName: "Customer name is a reqarid",
    CustomerAdd_Valid_FirstName: "First name is a reqarid",
    CustomerAdd_Valid_LastName: "Last name  is a reqarid",
    CustomerAdd_Valid_EMail: "E-mail is a reqarid",
    CustomerAdd_Valid_EMailFormat: "E-mail must be a valid e-mail",
    CustomerAdd_CustomerIdentificati: "Customer List",
    CustomerAdd_CompanyName: "Customer Name",
    CustomerAdd_UCCompanyName: "CUSTOMER NAME",
    CustomerAdd_OfficialPersonnel: "Official Personnel",

    Yes: "Yes",
    No: "No",
    FirstName: "First Name",
    LastName: "Last Name",
    EMail: "E-mail",
    PhoneNumber: "Phone Number",
    Phone: "Phone",
    Address: "Address",
    CountrySelect: "Select country ",
    CitySelect: "Select city",
    DistrictSelect: "Select district",
    AddressDetail: "Address Detail",
    CompanyDetail: "Company Detail",
    PleaseWait: "Please wait...",
    Users: "Users",
    Submit: "Submit",
    Save: "Save",
    Cancel: "Cancel",
    Search: "Search",
    Add: "Add",
    No_Records: "No Records Found",
    Add_All: "Add All",
    Delete: "Delete",
    Edit: "Edit",
    Update: "Update",
    Details: "Details",
    Detail: "Detail",
    Activate: "Activate",
    Deactivate: "Deactivate",
    Active: "Active",
    Passive: "Passive",
    Confirm: "Confirm",
    Remove: "Remove",
    Continue: " Continue",
    Other: "Other",
    Close: "Close",
    Clear: "Clear",
    Select_All: "SELECT ALL",
    Send_confirm: "Send For Approval",
    Confirm_Password: "Confirm Password",
    Select_Laguage: "Select Language",
    CheckList: "Checklists",
    NewHere: "New Here?",
    CreateAnAccount: "Create an Account",
    ForgotPassword: "Forgot Password?",
    Turkish: "Turkish",
    English: "English",
    RememberMe: "Remember Me",
    About: "About",
    Menu_CompanyPage: "Company Info",
    Menu_Companies: "Companies",
    Menu_Templates: "Templates",
    Menu_Users_UserRoleListPage: "User Roles",
    Menu_Users_UserListPage: "Users",
    Menu_Users: "User",
    Menu_AdminPanel: "Admın",
    Menu_Dashboard: "Home Page",
    Menu_Header: "Home",
    Menu_Language_Setting: "Languages Setting",
    Menu_Checklists_Items: "Checklists and Items",
    Menu_Audit_Definition: "Audit Items",
    Menu_Audit_Details: "Audit Detail",
    Menu_Audit_DetailsList: "Audit List",
    Menu_Audit_Departments: "Sections",
    Menu_Audit_Categories: "Categories",
    Menu_Audit_Questions: "Questions",
    Menu_Audit_Checklist: "Checklists",
    Menu_Audit: "Audit",
    Menu_Audits: "Audits",
    Menu_Analysis: "Data Analysis",
    Menu_Actions: "Audit Actions",
    Menu_Customers: "Customers",
    Menu_Customer_Definition: "Customer",
    Menu_Add_Customer: "Customers Definition ",
    Menu_Add_Location: "Locaiton Definition",
    Menu_List_Projects: "Projects",
    Menu_Add_Service: "Business Operations",
    Menu_Audit_Answers_Template: "Answer Template",
    Menu_side: "Side Menu",
    craft: "Crafted",
    pages: "Pages",
    profile: "Profile",
    profileOverview: "Overview",
    Projects: "Projects",
    campaigns: "Campaigns",
    documents: "Documents",
    connections: "Connections",
    wizards: "Wizards",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Account",
    accountOverview: "Overview",
    settings: "Settings",
    authentication: "Authentication",
    basicFlow: "Basic Flow",
    signIn: "Sign-in ",
    signUp: "Sign-up",
    signOut: "Sign Out",
    passwordReset: "Password Reset",
    error404: "Error 404",
    error500: "Error 500",
    project_list_column_name: "PROJECT NAME",
    project_field_name_label: "Project Name",
    project_list_title: "Projects",
    project_modal_tab_info: "Info",
    project_page_header_title: "Project List",
    project_button_add_new: "New Project",
    project_modal_edit_title: "Project Update",
    project_modal_add_title: "Project Add",
    project_field_published_label: "Published",
    project_list_column_published: "Published ?",
    project_modal_check_label_description: "Is the project system status active?",
    project_list_column_customer_name: "CUSTOMER",

    question_component_input_categoryId: "Categories",
    question_component_input_title: "Question Title",
    question_component_input_score: "Score",

    question_component_input_point: "Point",
    question_component_input_code: "Question Code",
    question_component_input_info: "Quetion Info",
    question_component_button_add_question: "Add Question",
    question_component_h3_content_title: "Question Content",
    question_component_button_add_answer: "Add Answer",
    question_component_li_answer_type_Single: "Button",
    question_component_li_answer_type_Multiple: "Multiple Select",
    question_component_li_answer_type_Radio: "Select",
    question_component_li_answer_type_Text: "Text",
    question_component_button_answer: "Answer",
    question_component_button_text_answer: "Text type answer",
    question_component_modal_label_answer_title: "Answer Title",
    question_component_modal_label_answer_score: "Score",
    question_component_modal_label_answer_orderBy: "View Order",
    question_component_modal_label_answer_nullAvailable:
      "If this answer is selected for the question, the question will be excluded from scoring.",

    question_component_button_questions_save: "Save Questions",
    question_component_button_add_multi_language: "Add language content",
    question_component_modal_multi_language_title: "Add Content by Languages",
    question_component_modal_multi_language_answers: "Answers",
    question_component_modal_multi_language_sub_answers: "Answer Options",
    question_component_input_select_category: "Select category",
    question_component_checkbox_label_info: "This is an information question",
    question_component_checkbox_label_info_icon_title:
      "Check this option if you want to generate a question to get information about the audit",

    question_component_answer_select_valid: "The answer type must be selected.",
    question_component_answer_modal_score_valid: "The answer score cannot be more than the question score.",
    question_component_validation_question_text: "Question sentence cannot be empty.",
    question_component_validation_answer_text: "Answer title cannot be empty.",
    question_component_delete_question_confirm_message: "Are you sure you want to delete the question?",
    question_component_answer_modal_checkbox_sub_option_score: "Add points to sub-options?",
    question_component_description:
      "This page is designed to create the questions you need for your audits. You can create a question content by clicking the button on the right. Rules to be considered when creating a question; The answer type must be selected for each question. Giving a code to the question gives you an advantage for reporting and search features. You can classify your questions according to the categories you have created before, it is not required to choose a category. After you approve your question content, you can create your content in different languages according to your working languages. Only approved questions will be recorded by the system.",

    question_component_page_title_h4: "QUESTION GENERATION PAGE",
    question_component_modal_button_add_sub_option: "Add Sub Option",
    question_component_modal_sub_option_input: "Sub Option Title",
    question_component_modal_h5_content_title: "Answer Content",
    question_component_column_category: "CATEGORY",
    question_component_column_title2: "QUESTION SENTENCE",
    question_component_column_info: "QUESTION TYPE",
    question_component_breadcrumbs: "Questions",
    question_component_breadcrumbs_list: "Question List",
    question_component_breadcrumbs_new: "New Question",
    question_component_name: "Question",
    question_component_button_backto_list: "Back To List",
    question_component_breadcrumbs_edit: "Editing a Question",
    question_component_answer_template: "Answer Templates",
    question_component_answer_template_select: "Select answer template",
    question_edit_page_title_h4: "QUESTION UPDATE PAGE",
    question_edit_button: "Edit Question",
    question_list_copy_button: "Soruyu Kopyala",

    checklist_component_column_title: "CHECKLIST NAME",
    checklist_component_button_add_checklist: "New CheckList",
    checks: "Checks",
    checklist_component_IdentificationPage: "Checklists",

    audit_departments: "Sections",
    audit_departments_validation_name: "Section name is required",
    audit_departments_breadcrumbs: "Section List",
    audit_departments_name: "Section",
    audit_departments_button_add_department: "New Section",
    audit_departments_list_colum_code: "SECTION CODE",
    audit_departments_list_colum_name: "SECTION NAME",
    audit_departments_list_colum_button_add_info_question: "Add information question to category",
    audit_departments_modal_label_name: "Section Name",
    audit_departments_modal_label_code: "Section Code",
    audit_departments_modal_check_label_description: "Is the system status of the section active?",

    audit_categorys: "Categories",
    audit_audit_categorys_validation_name: "Category name is required",
    audit_categorys_breadcrumbs: "Category List",
    audit_categorys_button_add_category: "New Category",
    audit_categorys_list_colum_code: "CATEGORY CODE",
    audit_categorys_list_colum_name: "CATEGORY NAME",
    audit_categorys_modal_label_name: "Category Name",
    audit_categorys_modal_label_code: "Category Code",
    audit_categorys_modal_label: "Category",
    audit_categorys_modal_check_label_description: "Is the system status of the category active?",

    user_table_column_header_fname: "FIRST NAME",
    user_table_column_header_lname: "LAST NAME",
    user_modal_label_full_name: "Full Name",
    user_modal_label_user_languge: "User Language",
    user_modal_label_user_role: "User Role",
    user_modal_select_user_role: "Select User Role",
    user_modal_check_label_active: "Active",
    user_modal_check_label_description: "Is the user's system status active?",
    user_modal_validation_fname: "Name information is required",
    user_modal_validation_lname: "Surname information is required",
    user_modal_validation_password: "Password information is required",
    user_modal_validation_email: "E-mail information is required",
    user_modal_validation_confirm_password: "Passwords must match",
    user_modal_validation_user_role: "Role selection is required",
    user_modal_check_label_auditor: "Is the user an auditor?",
    customer_user_table_header: "Users",

    UserTimeLine: "User Gestures",
    user_detail_comp_button_change_password: "Change Password",
    user_detail_comp_label_old_password: "Old Password",
    user_detail_comp_label_new_password: "New Password",
    user_detail_comp_label_comfirm_password: "Confirm New Password",
    user_detail_comp_label_ok_change_password: "Password change successful",
    user_detail_comp_button_update_password: "Update Password",
    user_detail_edit_label_image_avatar: "Avatar",
    user_detail_edit_save_avatar: "Save Avatar",
    user_detail_edit_remove_avatar: "Remove Avatar",
    user_detail_edit_change_avatar: "Change Avatar",
    user_detail_edit_label_image_avatar_file_types: "Allowed file types",
    user_detail_valid_new_pasword: "Password is a required field",
    user_detail_valid_confim_pasword: "Password confirmation is a required field",
    user_detail_valid_not_confim_pasword: "Passwords must match",
    user_detail_public_label_password: "Password",
    UserAuditLine: "Audit History",

    userGroup_detail_label_name: "User Group Name",
    userGroup_detail_title: "New User Group",
    userGroup_detail_title_update: "Update User Group",
    userGroup_detail_check_label: "Active",
    userGroup_detail_check_label_description: "Is the user Group system status active?",
    userGroups_detail_Valid_Name: "userGroup Name is a reqarid",
    userGroup_list: "USER GROUPS",
    userGroup_list_breadcrumb_titles: "User Groups List",
    userGroup_list_breadcrumb_title: "User Group List",
    userGroup_list_column_status: "STATUS",
    userGroup_list_column_name: "USER GROUP NAME",
    userGroup_list_add_button: "New Group",
    userGroup_list_permission_all: "Select All",
    company_modal_check_label: "Active",
    company_modal_check_label_description: "Is the Company system status active?",
    company_detail_location_list_title: "Add checklist template for selected Company",
    audit_planning_checklist_select: "Select Checklist",
    audit_planning_checklist_name: "Checklist",
    audit_planning_cproject_select: "Select Project",
    audit_planning_location_select: "Select Location",
    audit_planning_location_confirmation_check: "Is approval required??",
    audit_planning_location_confirmation: "Is management approval required?",
    audit_planning_beginDate_endDate_select: "Select Start Date and End Date",
    audit_planning_beginDate_select: "Select Start Date",
    audit_planning_endDate_select: "Select End Date",
    audit_planning_select_lead_auditor: "Select Auditor",
    audit_planning_select_audit_type: "Select Audit Type",
    audit_planning_audit_select_assistand_auditor: "Select assistand auditor",
    audit_planning_definition: "Write the definition of control",
    audit_planning_audit: "Audit Planning",
    audit_planning_audit_header: "Plan Information",
    audit_planning_audit_: "Plan Details",
    audit_planning_audit_select: "User Information",
    audit_planning_header: "Completed",
    audit_planning_definition_label: "Audit Definition",
    audit_planning_validation_definition: "Definition is required",
    audit_planning_validation_customer: "Customer name is required",
    audit_planning_validation_project: "Project name is required",
    audit_planning_validation_location: "Location name is required",
    audit_planning_validation_checklist: "Checklist name is required.",
    audit_planning_validation_lead_auditor: "Lead Auditor name is required. ",
    audit_planning_validation_user: "Assistant Auditor name is required.",
    audit_planning_validation_audit_type: "Audit Type name is required.",
    audit_planning_validation_beginDate: "Audit Begin date is required",
    audit_planning_validation_endDate: "Audit End date is required",
    audit_planning_validation_companyName: "Company Name is required",
    audit_planning_list_new: "New Audit Planning",
    audit_topbar: "New Audit",
    audit_planning_list_customer: "CUSTOMER NAME",
    audit_planning_list_audit_name: "AUDITER NAME",
    audit_planning_list_project: "PROJECT NAME",
    audit_planning_list_location: "LOCATION NAME",
    audit_planning_list_audit_type: "AUDIT TYPE",
    audit_planning_list_audit_date: "AUDIT DATE",
    audit_planning_list_header: "AUDIT PLANNING LIST",
    audit_planning_list_identification: "Audit Planning",
    audit_planning_list_identification_: "Audit Planning List",
    audit_planning_list_status: "STATUS",

    //Permissions
    PERMİSSİONS: "yetkiler",
    AccessAdminPanel: "Access Admin Panel",
    HtmlEditorManagePictures: "Html Editor Manage Pictures",
    ManageActivityLog: "Manage Activity Log",
    ManageCategories: "Manage Categories",
    ManageChecklists: "Manage Checklists",
    ManageCompanies: "Manage Companies",
    ManageCountries: "Manage Countries",
    ManageCustomers: "Manage Customers",
    ManageDepartments: "Manage Sections",
    ManageEmailAccounts: "Manage Email Accounts",
    ManageFiles: "Manage Files",
    ManageLocations: "Manage Locations",
    ManageMaintenance: "Manage Maintenance",
    ManageMessageQueue: "Manage Message Queue",
    ManageMessageTemplates: "Manage Message Templates",
    ManageOperationTypes: "Manage Operation Types",
    ManagePictures: "Manage Pictures",
    ManageProjects: "Manage Projects",
    ManagePushNotifications: "Manage Push Notifications",
    ManageReports: "Manage Reports",
    ManageScheduleTasks: "Manage Schedule Tasks",
    ManageSystemLog: "Manage System Log",
    ManageUserAttributes: "Manage User Attributes ",
    ManageUserGroups: "Manage User Groups",
    ManageUsers: "Manage Users",
    ManageActions: "Manage Actions",
    ManageAuditPlans: "Manage Audit Plans",
    ManageQuestions: "Manage Questions",
    ManageAuditActions: "Manage Audit Actions",
    ManageAuditAnalysis: "Manage Audit Analysis",
    ManageMyCompany: "Manage Company Information",
    ManageAnswerTemplates: "Manage Answer Templates",
    ActionAdd: "Action Add",
    ActionApproveOrReject: "Action Approve or Reject",

    company_detail_modal_label_default_language: "Default Language",
    company_detail_modal_label_name: "Company Name",
    company_modal_label_name: "Select Company",
    company_detail_label_contact_info: "Contact Information",
    companyAdd_Valid_FirstName: "project Name is a reqarid",
    company_detail_input_seacrh_placeholder: "Search Customer",
    company_detail_button_remove_locations: "Remove Customers",
    project_detail_location_input_seacrh_placeholder: "Search Location",
    project_detail_location_button_add: "Add Location",
    project_detail_location_button_remove_locations: "Remove Locations",
    project_detail_location_button_remove_projects: "Remove Projects",
    project_detail_location_list_title: "Add location for selected project",
    project_detail_user_input_seacrh_placeholder: "User Search",
    project_detail_user_button_add: "Add User",
    project_detail_user_button_remove_users: "Remove Users",
    project_detail_user_list_title: "Add user for selected project",
    project_detail_checklist_input_seacrh_placeholder: "Search Checklist",
    project_detail_checklist_button_add: "Add Checklist",
    project_detail_checklist_button_remove_checklists: "Remove Checklists",
    project_detail_checklist_list_title: "Add checklist for selected project",
    project_new_project_search: "search Project",
    ChecklistTemplate: "Checklist Template",
    project_achievementlevels_label_min_value: "Minimum Value",
    project_achievementlevels_label_max_value: "Maximum Value",
    project_achievementlevels_button_add: "Add Achievement Level",
    project_achievementlevels_modal_create_title: "Add Achievement Level",
    project_achievementlevels_modal_edit_title: "Update Achievement Level",
    project_achievementlevels_modal_name_label: "Achievement Level Name",
    project_achievementlevels_modal_level_required: "Achievement level name is required",
    project_achievementlevels_modal_level_label: "Level Range",
    Max: "Max",
    Min: "Min",
    AchievementLevels: "Achievement Levels",

    customer_location_confirm_message: "Are you sure you want to delete the customer location?",
    customer_location_confirm_acceptLabel: "Yes",
    customer_location_confirm_rejectLabel: "No",

    checklist_create_modal_h5: "Question List",
    checklist_create_modal_checkbox_label: "Info Question",
    checklist_create_modal_filter_input: "Search questions",
    checklist_create_modal_select: "Select category",
    checklist_create_page_title: "CHECKLIST CREATION PAGE",
    checklist_edit_page_title: "CHECKLIST UPDATE PAGE",
    checklist_create_input_name: "Checklist Name",
    checklist_create_label_department: "Sections",
    checklist_create_select_department: "Select section",
    checklist_create_input_signature: "Signature Section",
    checklist_create_accordion_checkinfo_button: "Checklist Info Questions",
    checklist_create_button_add_question: "Add Question",
    checklist_create_button_selected_add_question: "Add Question to Selected Sections",
    checklist_create_button_select_all: "Select All",
    checklist_create_accordion_button_info: "Info",
    checklist_name_validation: "Checklist name cannot be empty",
    checklist_question_button: "Questions",
    checklist_msg_add_question: "Question successfully added",
    checklist_msg_add_error_question: " previously added",
    checklist_msg_add_question_1: " No questions have been added to the section.",
    checklist_create_breadcrumbs_list: "Checklists",
    checklist_create_breadcrumbs_new: "New Checklist",
    checklist_datatable_button_title: "Copy Checklist",
    answers_template_modal_validation_template_type: "Answer type cannot be empty",
    answers_template_modal_validation_template_name: "Answer title cannot be empty",
    answers_template_modal_label_template_checkbox: "Let this answer template exclude the question from scoring",
    answers_template_modal_select_template_pleaceholder: "Choose answer type",
    answers_template_modal_label_template_type: "Answer Types",
    answers_template_modal_label_template_name: "Answer Title",
    answers_template_modal_title_new: "New Answer Template",
    answers_template_modal_title_edit: "Edit Answer Template",
    answers_template_list_button_new: "New Answer Template",
    answers_template_list_title: "Answer Templates",
    answers_template_list_column_title: "ANSWER TEMPLATE NAME",
    answers_template_list_breadcrumbs: "Answer Templates",
    answers_template_list_breadcrumbs_title: "Answer Template List",
    profile_photo: "Profile Photo",

    audit_report_main_title_informations: "INFORMATION",
    audit_report_non_conformity_report: "Non-Conformity Report",
    audit_report_pdf_reportt: "Report PDF",
    audit_report_action_report: "Action Report",
    audit_report_reset_pdf_report: "Reset Pdf Report",
    audit_report_main_title_sections: "SECTIONS AND CATEGORIES",
    audit_report_main_title_audit_detail: "AUDIT DETAILS",
    audit_report_section_department: "SECTION",
    audit_report_section_category: "CATEGORY",
    audit_report_section_available_score: "POINTS THAT CAN BE OBTAINED WITHIN THE SECTION",
    audit_report_section_received_score: "POINTS RECEIVED IN THE SECTION",
    audit_report_section_success_rate: "IN-SECTIONAL ACHIEVEMENT SCORE",
    audit_report_details_question_code: "QUESTION CODE",
    audit_report_details_question: "QUESTION",
    audit_report_details_question_score: "SCORE",
    audit_report_details_question_answer: "ANSWER",
    audit_report_details_non_conformity: "Reason for Non-conformity",
    audit_report_details_evidence: "Evidence",
    audit_report_details_process: "Process",
    audit_report_details_information_question: "Information Question",
    audit_report_details_information_questions: "Information Questions",
    audit_report_summary_location: "Location",
    audit_report_summary_audit_date: "Audit Date",
    audit_report_summary_appropriate_answer_count: "Number of questions with full marks",
    audit_report_summary_inappropriate_answer_count: "Number of non-full questions",
    audit_report_summary_TotalEarnedScore: "Total Earned Score",
    audit_report_summary_total_available_score: "Total Available Score",
    audit_report_summary_achievement_level: "Success Status",
    audit_report_summary_achievement_score: "Succes Rate",
    audit_report_summary_auditer: "Auditor",
    audit_report_delete_photo: "Delete Photo",
    audit_report_delete_video: "Delete Video",
    audit_report_category_chart: "Category Score Chart ",
    audit_report_department_chart: "Section Score Chart ",
    audit_report_answer_distribution: "Audit Answer Distribution",
    audit_report_section_not_avaliable: "No section information available",
    audit_report_summary_not_avaliable: "No summary information available",
    audit_report_answer_not_avaliable: "No answer information available",
    audit_report_detail_not_avaliable: "No detail information available",
    audit_report_answers_title: "ANSWERS",

    file_picture: "Allowed file types: jpg, jpeg. png",
    sign_in_message_password: "The password is incorrect",
    sign_in_message_password_again: "Please try again",
    sign_in_message_user: "User not found",
    sign_in_message_user_detail: "Check the information",
    sign_in_message_success: "Login succesful",
    sign_in_message_success_detail: "Information is correct",
    edit_answer: "Edit Answer",
    edit_answer_open_video: "Open Video",
    edit_answer_open_photo: "Open Photo",
    send_approve: "Approve",
    audit_pending_approval: "Audit is pending approval",
    audit_approve_message: "Are you sure want to approve the audit?",
    audit_approved: "Audit approved.",
    //SONRADAN EKLENEN KELİMELER
    confirm_message_location: "Are you sure want to delete the location?",
    confirm_message_customer: "Are you sure want to delete the customer?",
    confirm_message_project: "Are you sure want to delete the project?",
    confirm_message_operation: "Are you sure want to delete the operation?",
    confirm_message_user: "Are you sure want to delete the user?",
    confirm_message_userrole: "Are you sure want to delete the user role?",
    confirm_message_department: "Are you sure want to delete the section?",
    confirm_message_category: "Are you sure want to delete the category?",
    confirm_message_answer_template: "Are you sure want to delete the answer template?",
    confirm_message_question: "Are you sure want to delete the question?",
    confirm_message_checklist: "Are you sure want to delete the checklis??",
    confirm_message_plan: "Are you sure want to delete the aupit plan?",
    confirm_message_cproject: "Are you sure want to delete the customer project?",
    confirm_message_clocation: "Are you sure want to delete the customer location?",
    confirm_message_cuser: "Are you sure want to delete the customer user?",
    confirm_message_img: "Are you sure want to delete the photo?",
    confirm_message_company: "Are you sure want to delete the company?",
    confirm_message_locations: "Are you sure want to delete the selected locations?",
    confirm_message_customers: "Are you sure want to delete the selected customers?",
    confirm_message_projects: "Are you sure want to delete the selected projects?",
    confirm_message_operations: "Are you sure want to delete the selected operations?",
    confirm_message_users: "Are you sure want to delete the selected users?",
    confirm_message_userroles: "Are you sure want to delete the selected roles?",
    confirm_message_departments: "Are you sure want to delete the selected sections?",
    confirm_message_categories: "Are you sure want to delete the selected categories?",
    confirm_message_answer_templates: "Are you sure want to delete the selected templates?",
    confirm_message_questions: "Are you sure want to delete the selected questions?",
    confirm_message_checklists: "Are you sure want to delete the selected lists?",
    confirm_message_plans: "Are you sure want to delete the selected plans?",
    confirm_message_cprojects: "Are you sure want to delete the selected projects?",
    confirm_message_clocations: "Are you sure want to delete the selected locations?",
    confirm_message_cusers: "Are you sure want to delete the selected users?",
    confirm_message_companies: "Are you sure want to delete the selected companies?",
    confirm_exit_page: "Your changes will be deleted permanently, close the page anyway",

    confirm_profile_page: "Old password is wrong",
    confirm_checklist: "Checklist already in use",
    confirm_question: "Question already in use",
    confirm_warning: "Warning",
    confirm_delete_profile_image: "Your profile picture will be deleted, are you sure?",
    profile_page_change_password_valid_oldpassword: "Old password is required",
    profile_page_breadcrumbs: "My profile",

    dashboard_audits: "Audits",
    dashboard_day_week_month: " Daily, Weekly, Monthly",
    dashboard_day: "Today",
    dashboard_week: "This week",
    dashboard_month: "This month",
    dashboard_completed_audit: "Completed Audit",
    dashboard_card_icon_out_of_date: "Out of Date Audit",
    dashboard_card_icon_upcoming_audit: "Upcoming Audit",
    dashboard_pending_approval: "Audits Pending Approval",
    dashboard_pending_description: "Location and date of the audit",
    dashboard_customers_audit: "Customers and Audits",
    dashboard_customers_audit_number: "Number of customer audits",
    dashboard_week_apexchart: "Weekly",
    dashboard_month_apexchart: "Monthly",
    dashboard_year_apexchart: "Yearly",
    dashboard_week_apexchart_title: "Number of Audit Weekly",
    dashboard_month_apexchart_title: "Number of Audit Monthly",
    dashboard_year_apexchart_title: "Number of Audit Yearly",
    dashboard_location: "location",
    dashboard_audit: "audit",
    dashboard_audit_number: "Number of Audit",
    dashboard_no_planned_audit_today: "No audits are planned today",
    dashboard_no_planned_audit_week: "No audits are planned this week",
    dashboard_no_planned_audit_month: "No audits are planned this month",
    dashboard_loading: "Loading...",
    dasboard_approval_confirm: "There are no controls pending approval",
    dashboard_card_customer_confirm: "No customer information",
    dashboard_audit_score: "Audit Score",
    dashboars_audit_rights: "Audit Quota",
    dashboard_remaining_rights_subscriptions: "Remaining quota from your existing subscription",
    dashboard_remaiming: "Remaining",
    dashboard_view_detail: "View Details",
    dashbord_total_rights: "Total Quota",
    dashboard_remaining_rights: "Remaining Quota",
    dashboard_passive: "Passive",
    dashboard_subscription_details: "Quota Details",
    dashbodard_begin_date: "Begin Date",
    dashboard_end_date: "End Date",
    dashboard_status: "Status",

    //Analiz sayfasıanalysis_score
    analysis: "Analysis",
    analysis_page_title: "Analysis Page",
    analysis_all_customer: "All customers",
    analysis_all_location: "All locations",
    analysis_all_project: "All projects",
    analysis_date_input: "gg.aa.yy",
    analysis_total: "Total",
    analysis_number_of_audits_by_score: "Number of Audits by Score",
    analysis_number_of_locations_by_type_of_activity: "Number of Locations by Type of Activity",
    analysis_type_of_activity_total: "types of activities",
    analysis_audit_results: "Audit Results",
    analysis_date_check_list: "Date/Checklist",
    analysis_audit_result: "Audit Result",
    analysis_score: "score",
    analysis_no_audit: "No audits",
    analysis_no_location_activity_type: "No location with the activity type",
    analysis_project: "Project",
    analysis_no_data_criterie: "No data found matching your criteria",
    analysis_operation_type_title: "Audit Score by Operation Type",
    analysis_operation_type_name: "OPERATION TYPE",
    analysis_operation_type_audit_count: "AUDIT COUNT",
    analysis_operation_type_score: "ACHIEVEMENT SCORE",
    analysis_checklist_dropdown_all: "All Checklists",
    analysis_auditor_title: "Number Of Audits By Auditors",
    analysis_checklist_tab_info: "There is ",
    analysis_checklist_tab_info_after: " audit in these criteria",
    analysis_results: "Results of ", //audit
    analysis_result_info: "audits are shown",
    analysis_checklist_answer_distribution: "Checklist Answer Distribution",
    analysis_requiring_action: "Questions Requiring The Most Action",
    analysis_category_based_distribution: "Category Based Distribution",
    analysis_department_based_distribution: "Department Based Distribution",
    analysis_department_score: "Score analysis",
    analysis_department_answer: "Answer analysis",
    analysis_department_comparison: "Comparison",
    analysis_department_comparison_subtitle: "Results from the last 2 audits at the location are shown",
    analysis_answer_count: "Answer Count",
    analysis_last_audits_pie_chart: "Pie Chart",
    analysis_last_ten_audits: "Last 10 Audits Analysis",
    analysis_last_audits_table: "Table",
    analysis_category_tab_title: "CATEGORY",
    analysis_department_tab_title: "DEPARTMENT",
    analysis_average_score: "AVERAGE SCORE",
    analysis_first_audit: "1. Audit",
    analysis_second_audit: "2. Audit",
    analysis_count: "Count",

    //answer template
    answerTemplate_state_select: "Answer State",
    answerTemplate_state_select_box: "Select Answer State",
    Menu_Audit_Answers_State: "Answer States",
    answerTemplate_state_select_name: "Answer State Name",

    //Add User Modal
    user_modal_label_user_time_zone: "Time Zone",
    user_modal_select_user_time_zone: "Select time zone",
    user_modal_validation_time_zone: "Time zone selection is required",

    // User Detail
    user_detail_confirm_delete_profile_image: "Profile picture will be deleted, are you sure?",

    // Question Comp
    question_comp_input_checkbox_type_text: "Set reply type as text",
    question_comp_input_btn_select_template: "Select Template",
    question_comp_input_btn_save_template: "Save Template",
    question_comp_save_template_modal_title: "New Template",
    question_comp_save_template_modal_label_name: "Template Name",
    question_comp_save_template_search: "Search Template",
    question_comp_remove_template: "Remove Template",
    question_comp_save_template_modal_form_name_valid: "Template name is required",
    question_comp_tepmlate_list_title: "Question Template List",
    question_comp_tepmlate_list_confirm_delete_msg: "The selected template will be deleted, are you sure?",
    question_comp_tepmlate_list_confirm_delete_all_msg: "All templates will be deleted, are you sure?",
    delete_all: "Delete All",

    question_component_li_answer_type_DateTime: "Date",
    question_component_li_answer_type_Phone: "Phone",
    question_component_li_answer_type_Signature: "Signature",
    question_component_li_answer_type_Location: "Location",
    question_component_checkbox_required: "Required",
    question_component_checkbox_required_title: "This option indicates that answering the question is mandatory",
    question_component_answer_modal_action_checkbox_label: "Action Require",
    question_component_answer_modal_action_checkbox_title:
      "If this answer is selected for the question, action must be taken",
    question_component_answer_modal_evidence_checkbox_label: "Evidence Require",
    question_component_answer_modal_evidence_checkbox_title:
      "If this answer is selected for the question, evidence must be provided",
    question_component_answer_modal_evidence_options_title: "Require evidence",
    question_component_answer_modal_evidence_options_explication:
      "Choose the evidence that’ll be required when this answer is selected.",
    question_component_answer_modal_evidence_options_notes: "Notes",
    question_component_answer_modal_evidence_options_media: "Media",
    question_component_answer_modal_label_logic_choice: "Logic Selection",
    question_component_answer_modal_na_checkbox_label: "NA",

    //Checklist Page
    checklist_page_total_number_question: "Total number of questions",
    checklist_page_number_question: "Number of questions",
    checklist_page_total_score: "Total score",
    checklist_page_score: "Score",
    checklist_page_info_description:
      "If you want to divide the checklist information section into sections, select the sections you want from the list below.",
    checklist_page_info_title: "Checklist Info Section",
    checklist_page_sections_description:
      "If you want to divide your checklist into sections, select the sections you want from the list below.",

    logo: "Logo",

    action_locaion_list_header: "Audit With Action Information",
    action_status_column: "ACTION STATUS",
    action_approve_status: "APPROVAL STATUS",
    action_date_range: "Action Date Range",
    action_text: "Action Text",
    action_person_change: "Person in charge of action in the location",
    action_approval_status: "Approval status",
    no_action: "No Action",
    action_select_all_approved: "Confirm selections",
    action_select_all_reject: "Reject selections",
    action_select_all_send: "Send Selections",
    action_related_questions: "Related Questions",
    action_add_screen: "Add Action",
    add_action_required_date_begin: "Begin date is required",
    add_action_required_date_end: "End date is required",
    add_action_required_text: "Action text is required",
    add_action_person_charge: "Person in charge is required",
    action_list: "Action List",
    action_audit_list: "Audit Actions List",
    audit_detail_required_answer: "The question must be answered",
    action_send_for_approve: "Are you sure want to send the entered action for approval?",
    action_approve_confirm_message: "Are you sure want to confirm the entered action?",
    action_reject_confirm_message: "Are you sure want to reject the entered action?",

    // Template Pages
    template_list_page_title: "Template List",
    template_list_name_column_title: "TEMPLATE NAME",
    template_list_add_button_new_template: "Add Template to Selected Customer",
    template_list_button_new_template: "New Template",
    menu_item_template_answers: "Template Answer Keys",
    menu_item_template_category: "Template Categories",
    menu_item_template_sections: "Template Sections",
    menu_item_template_questions: "Template Questions",
    menu_item_template: "Templates",
    menu_system_admin: "SYSTEM ADMINISTRATOR",
    template_published_check_label_description: "Is the template system status active?",

    company_list_page_title: "Company List",
    company_new: "New Company",
    company_name: "COMPANY NAME",

    checklist_template_component_column_title: "TEMPLATE NAME",
    checklist_template_component_a_title: "Copy Template",
    checklist_template_component_title: "Checklist Templates",
    checklist_template_not_template: "Your company does not have a template",
    checklist_template_confirm_copy: "Are you sure you want to copy the template?",
    register_login_text: "Dont you have an account?",
    register_login_link: "Sign Up",
    register_form_title: "Create your account",
    register_form_subtitle: "Do you have an account?",
    register_form_link_title: "Sign In",
    register_form_user_information: "User Information",
    register_form_company_information: "Company Information",
    register_form_password_information: "Password Information",
    register_form_company_name: "Company Name",
    register_form_company_phone: "Company Phone",
    register_form_company_email: "Company Email",
    register_form_company_street_address: "Company Street Address",
    register_form_company_description: "Company Description",
    register_form_district: "District",
    register_form_street_address: "Street Address",
    register_form_company_country: "Company Country",
    register_form_company_city: "Company City",
    register_form_company_district: "Company District",

    // Searh Input Componentinde Kullanılan Filter Key
    locationCode: "Code",
    cityName: "City",
    countryName: "Country",
    locationName: "Name",
    questionText: "Question Text",
    code: "Code",
    name: "Name",
  },
  tr: {
    user_list_button_new_user: "Yeni Kullanıcı",
    user_list_page_bread: "Kullanıcılar",
    user_list_page_bread_title: "Kullanıcı Listesi",
    customer_detail_button_edit: "Düzenle",
    customer_detail_label_company_detail: "Şirket Detayı",
    customer_detail_label_adress: "Adres",
    customer_detail_label_country: "Ülke",
    customer_detail_label_email: "Email",
    customer_detail_label_contact_phone: "İletişim Telefonu",
    customer_detail_label_personel: "Yetkili",
    customer_detail_label_name: "Müşteri Adı",
    customer_detail_label: "Müşteri",
    location_list_breadcrumb_title: "Lokasyon Listesi",
    location_list_column_status: "STATÜ",
    location_list_column_country: "ÜLKE",
    location_list_column_customer: "MÜŞTERİ",
    location_list_column_code: "KOD",
    location_list_column_name: "ADI",
    location_list_add_button: "Yeni Lokasyon",
    location_modal_check_label: "Aktif",
    location_modal_check_label_description: "Lokasyonun sistem durumu aktif mi?",
    location_modal_select_statu: "Lokasyon tipi seçiniz",
    location_modal_label_select_status: "Lokasyon Tipi",
    location_modal_select_oparation_type: "Faaliyet tipi seçiniz",
    location_modal_customer_placeholder: "Müşteri Seçiniz",
    location_modal_name: "Lokasyon Adı",
    location_modal_code: "Lokasyon Kodu",
    location_user: "Kullanıcı Lokasyonu",
    location_modal_validation_name: "Lokasyon ismi zorunludur",
    location_modal_validation_customer: "Müşteri seçimi zorunludur",
    NewLocation: "Yeni Lokasyon",
    Locations: "Lokasyonlar",
    ActivitiyTypeNew: "Yeni Faaliyet",
    ActivitiyTypeUpdateTitle: "Faaliyet Güncelle",
    ActivitiyTypeAddTitle: "Faaliyet Ekle",
    PhoneNumber_UC: "TELEFON",
    EMail_UC: "E-POSTA",
    Official: "Yetkili Kişi",
    Official_UC: "YETKİLİ KİŞİ",
    Country: "Ülke",
    Country_UC: "ÜLKE",
    Delete_Select: "Seçimi Sil",
    Records_Found: "Kayıt Bulundu",
    ActivitiyTypeAdd_5: "FAALİYET ADI",
    ActivitiyTypeAdd_4: "Faaliyet Adı",
    ActivitiyTypeAdd_3: "Faaliyet Tipleri",
    ActivitiyTypeAdd_2: "Bilgi",
    ActivitiyTypeAdd_1: "Faaliyet Tipi Tanımlama",
    ActivitiyTypeAdd_Business_Activity_Type_Page: "Faaliyet Listesi",
    ActivitiyTypeAdd_Valid_Name: "Faaliyet adı zorunludur",
    customer_modal_check_label: "Aktif",
    customer_modal_check_label_description: "Müşterinin sistem durumu aktif mi?",
    CustomersAdd_New: "Yeni Müşteri",
    Customers: "Müşteriler",
    CustomerAdd_CustomerIdentificationPage: "Müşteri Listesi",
    CustomerAdd_Valid_CompanyName: "Müşteri adı boş geçilemez",
    CustomerAdd_Valid_FirstName: "Personel adı boş geçilemez",
    CustomerAdd_Valid_LastName: "Personel soyadı  boş geçilemez",
    CustomerAdd_Valid_EMail: "E-posta boş geçilemez",
    CustomerAdd_Valid_EMailFormat: "E-posta uygun formatta olmalı ",
    CustomerAdd_CustomerIdentificati: "Müşteri Listesi",
    CustomerAdd_CompanyName: "Müşteri Adı",
    CustomerAdd_UCCompanyName: "MÜŞTERİ ADI",
    CustomerAdd_OfficialPersonnel: "Yetkili Personel",
    Projects: "Projeler",
    Yes: "Evet",
    No: "Hayır",
    FirstName: "Ad",
    LastName: "Soyad",
    EMail: "E-posta",
    PhoneNumber: "Telefon Numarası",
    Phone: "Telefon",
    Address: "Adres",
    CountrySelect: "Ülke seçiniz",
    CitySelect: "Şehir seçiniz",
    DistrictSelect: "İlçe seçiniz",
    AddressDetail: "Adres Detayı",
    CompanyDetail: "Firma Detayı",
    PleaseWait: "Lütfen bekleyin...",
    Users: "Kullanıcılar",
    Submit: "Gönder",
    Save: "Kaydet",
    Cancel: "İptal Et",
    Search: "Ara",
    Add: "Ekle",
    Add_All: "Hepsini Ekle",
    Delete: "Sil",
    Edit: "Düzenle",
    Update: "Güncelle",
    Details: "Detay",
    Detail: "Detay",
    Activate: "Aktif Et",
    Deactivate: "Engelle",
    Active: "Aktif",
    Passive: "Pasif",
    Confirm: "Onayla",
    Send_confirm: "Onaya Gönder",
    Confirm_Password: "Şifreyi Onayla",
    Close: "Kapat",
    Select_All: "HEPSİNİ SEÇ",
    Clear: "Temizle",
    Remove: "Kaldır",
    Continue: " Giriş",
    Other: "Diğer",
    No_Records: "Kayıt bulunamadı",
    Select_Laguage: "Dil Seçin",
    CheckList: "Kontrol Listeleri",
    signIn: "Giriş Yap",
    signUp: "Sign-up",
    signOut: "Çıkış Yap",
    NewHere: "Hesabın yok mu?",
    CreateAnAccount: "Hesap oluştur",
    account: "Hesap",
    Turkish: "Türkçe",
    English: "İngilizce",
    ForgotPassword: "Şifreni mi unuttun?",
    RememberMe: "Beni Hatırla",
    About: "Hakkımızda",
    Menu_CompanyPage: "Firma Bilgileri",
    Menu_Companies: "Firmalar",
    Menu_Templates: "Şablonlar",
    Menu_Users_UserRoleListPage: "Kullanıcı Rolleri",
    Menu_Users_UserListPage: "Kullanıcılar",
    Menu_Users: "Kullanıcı",
    Menu_AdminPanel: "Admin",
    Menu_Dashboard: "Ana Sayfa",
    Menu_Header: "Ana Sayfa",
    Menu_Language_Setting: "Dil Ayarları",
    Menu_Audit_Departments: "Bölümler",
    Menu_Audit_Categories: "Kategoriler",
    Menu_Audit_Questions: "Sorular",
    Menu_Audit_Checklist: "Kontrol Listeleri",
    Menu_Checklists_Items: "Listeler ve Öğeler",
    Menu_Audit_Definition: "Denetim Bileşenleri",
    Menu_Audit_Details: "Denetim Detay",
    Menu_Audit_DetailsList: "Denetim Listesi",
    Menu_Audit: "Denetim",
    Menu_Audits: "Denetimler",
    Menu_Analysis: "Veri Analizi",
    Menu_Actions: "Denetim Aksiyonları",
    Menu_Customers: "Müşteriler",
    Menu_Customer_Definition: "Müşteri",
    Menu_Add_Customer: "Müşteri Tanımlama",
    Menu_Add_Location: "Lokasyon Tanımlama",
    Menu_List_Projects: "Projeler",
    Menu_Add_Service: "İşletme Faaliyetleri",
    Menu_Audit_Answers_Template: "Cevap Şablonları",
    Menu_side: "Yan Menü",
    error404: "Hata 404",
    error500: "Hata 500",
    project_list_column_name: "PROJE ADI",
    project_field_name_label: "Proje Adı",
    project_list_title: "Projeler",
    project_modal_tab_info: "Bilgi",
    project_page_header_title: "Proje Listesi",
    project_button_add_new: "Yeni Proje",
    project_modal_edit_title: "Projeyi Güncelle",
    project_modal_add_title: "Proje Ekle",
    project_field_published_label: "Aktif",
    project_list_column_published: "Aktif ?",
    project_modal_check_label_description: "Projenin sistem durumu aktif mi?",
    project_list_column_customer_name: "MÜŞTERİ",

    question_component_input_categoryId: "Kategoriler",
    question_component_input_title: "Soru Cümlesi",

    question_component_input_score: "Puan",
    question_component_input_point: "Puan",
    question_component_input_code: "Soru Kodu",
    question_component_input_info: "Bilgi",
    question_component_button_add_question: "Yeni Soru Ekle",
    question_component_h3_content_title: "Soru İçeriği",
    question_component_button_add_answer: "Cevap Ekle",
    question_component_li_answer_type_Single: "Buton",
    question_component_li_answer_type_Multiple: "Çoklu Seçim",
    question_component_li_answer_type_Radio: "Seçim",
    question_component_li_answer_type_Text: "Metin",
    question_component_button_answer: "Cevap",
    question_component_button_text_answer: "Metin tipinde cevap",
    question_component_modal_label_answer_title: "Cevap Başlığı",
    question_component_modal_label_answer_score: "Puan",
    question_component_modal_label_answer_orderBy: "Görünüm Sırası",
    question_component_modal_label_answer_nullAvailable: "Soru için bu cevap seçilirse, soru puanlama dışı bırakılır.",

    question_component_button_questions_save: "Soruları Kaydet",
    question_component_button_add_multi_language: "Dil içeriği ekle",
    question_component_modal_multi_language_title: "Dillere Göre İçerik Ekle",
    question_component_modal_multi_language_answers: "Cevaplar",
    question_component_modal_multi_language_sub_answers: "Cevap Seçenekleri",
    question_component_input_select_category: "Kategori seç",
    question_component_checkbox_label_info: "Bu bir bilgi sorusudur",
    question_component_checkbox_label_info_icon_title:
      "Denetim ile ilgili bilgi almak amaçlı soru üretmek isterseniz bu seçeneği işaretleyin",
    question_component_answer_select_valid: "Cevap tipi seçilmesi zorunludur.",
    question_component_answer_modal_score_valid: "Cevap puanı, soru puanından fazla olamaz.",
    question_component_answer_modal_checkbox_sub_option_score: "Alt seçeneklere puan eklensin mi ?",
    question_component_validation_question_text: "Soru cümlesi boş geçilemez",
    question_component_validation_answer_text: "Cevap başlığı boş geçilemez",
    question_component_delete_question_confirm_message: "Soruyu silmek istediğinden emin misin?",
    question_component_description:
      "Bu sayfa, denetimleriniz için lazım olan sorularınızı oluşturmak için tasarlanmıştır. Sağ tarafta bulunan butona tıklayarak yanibir soru içeriği oluştura bilirsiniz. Soru oluştururken dikkat edilmesi gereken kurallar; Her soru için cevap tipi seçilmek zorundadır. Soruya kod vermek raporlama ve arama özellikleri için size avantaj kazandırır. Sorularınızı daha önceden oluşturmuş olduğunuz kategorilere göre sınıflandıra bilirsiniz, kategori seçmek zorunlu değildir. Soru içeriğinizi onayladıktan sonra çalışma dillerinize göre farklı dillerde içeriklerinizi oluştura bilirsiniz. Sadece onaylanmış olan sorular sistem tarafından kayıt edilecektir.",
    question_component_page_title_h4: "SORU OLUŞTURMA SAYFASI",
    question_component_modal_button_add_sub_option: "Alt Seçenek Ekle",
    question_component_modal_sub_option_input: "Alt Seçenek Başlığı",
    question_component_modal_h5_content_title: "Cevap İçeriği",
    question_component_column_title2: "SORU CÜMLESİ",
    question_component_column_info: "SORU TİPİ",
    question_component_column_category: "KATEGORİ",
    question_component_breadcrumbs: "Sorular",
    question_component_breadcrumbs_list: "Soru Listesi",
    question_component_breadcrumbs_new: "Yeni Soru",
    question_component_name: "Soru",
    question_component_button_backto_list: "Listeye Dön",
    question_component_breadcrumbs_edit: "Soru Düzenleme",
    question_component_answer_template: "Cevap Şablonları",
    question_component_answer_template_select: "Cevap şablonu seç",

    question_edit_page_title_h4: "SORU DÜZENLEME SAYFASI",
    question_edit_button: "Soruyu Düzenle",
    question_list_copy_button: "Copy Question",

    checklist_component_column_title: "KONTROL LİSTESİ ADI",
    checklist_component_button_add_checklist: "Yeni Liste",
    checks: "Kontroller",
    checklist_component_IdentificationPage: "Kontrol Listeleri",

    customer_location_confirm_message: "Müşteri lokasyonunu silmek istediğinize emin misiniz?",
    customer_location_confirm_acceptLabel: "Evet",
    customer_location_confirm_rejectLabel: "Hayır",

    audit_departments: "Bölümler",
    audit_departments_validation_name: "Bölüm adı zorunludur",
    audit_departments_breadcrumbs: "Bölüm Listesi",
    audit_departments_name: "Bölüm",
    audit_departments_button_add_department: "Yeni Bölüm",
    audit_departments_list_colum_code: "BÖLÜM KODU",
    audit_departments_list_colum_name: "BÖLÜM ADI",
    audit_departments_list_colum_button_add_info_question: "Kategoriye bilgilendirme sorusu ekle",
    audit_departments_modal_label_name: "Bölüm Adı",
    audit_departments_modal_label_code: "Bölüm Kodu",
    audit_departments_modal_check_label_description: "Bölümün sistem durumu aktif mi?",

    audit_categorys: "Kategoriler",
    audit_audit_categorys_validation_name: "Kategori adı zorunludur",
    audit_categorys_breadcrumbs: "Kategori Listesi",
    audit_categorys_button_add_category: "Yeni Kategori",
    audit_categorys_list_colum_code: "KATEGORİ KODU",
    audit_categorys_list_colum_name: "KATEGORİ ADI",
    audit_categorys_modal_label_name: "Kategori Adı",
    audit_categorys_modal_label_code: "Kategori Kodu",
    audit_categorys_modal_label: "Kategori",
    audit_categorys_modal_check_label_description: "Kategorinin sistem durumu aktif mi?",

    user_table_column_header_fname: "AD",
    user_table_column_header_lname: "SOYAD",
    user_modal_label_full_name: "Ad Soyad",
    user_modal_label_user_languge: "Kullanıcı Dili",
    user_modal_label_user_role: "Kullanıcı Rolü",
    user_modal_select_user_role: "Kullanıcı Rolünü Seç",
    user_modal_check_label_active: "Aktif",
    user_modal_check_label_description: "Kullanıcının sistem durumu aktif mi?",
    user_modal_validation_fname: "Ad bilgisi zorunludur",
    user_modal_validation_lname: "Soyad bilgisi zorunludur",
    user_modal_validation_password: "Şifre bilgisi zorunludur",
    user_modal_validation_email: "E-posta bilgisi zorunludur",

    user_modal_validation_confirm_password: "Şifreler aynı olmalıdır",
    user_modal_validation_user_role: "Rol seçimi zorunludur",
    user_modal_check_label_auditor: "Kullanıcı bir denetçi mi?",

    UserTimeLine: "Kullanıcı Geçmişi",
    user_detail_comp_button_change_password: "Şifre Değiştir",
    user_detail_comp_label_old_password: "Eski Şifre",
    user_detail_comp_label_new_password: "Yeni Şifre",
    user_detail_comp_label_comfirm_password: "Yeni Şifreyi Tekrarla",
    user_detail_comp_label_ok_change_password: "Şifre değiştirme başarılı",
    user_detail_comp_button_update_password: "Şifre Güncelle",
    user_detail_edit_label_image_avatar: "Resim",
    user_detail_edit_save_avatar: "Resmi Kaydet",
    user_detail_edit_remove_avatar: "Resmi Sil",
    user_detail_edit_change_avatar: "Resmi Değiştir",
    user_detail_edit_label_image_avatar_file_types: "İzin verilen dosya türleri",
    user_detail_valid_new_pasword: "Şifre girmek zorunludur",
    user_detail_valid_confim_pasword: "Şifre onayı gerekli bir alandır",
    user_detail_valid_not_confim_pasword: "Şifreler aynı olmalıdır",
    user_detail_public_label_password: "Şifre",
    UserAuditLine: "Denetim Geçmişi",

    company_detail_modal_label_default_language: "Varsayılan Dil",
    company_detail_modal_label_name: "Firma Adı",
    company_modal_label_name: "Firma Seçiniz",

    company_detail_label_contact_info: "İletişim Bilgileri",

    userGroup_detail_label_name: "Kullanıcı Grup Adı",
    userGroup_detail_title: "Yeni Kullanıcı Rolü",
    userGroup_detail_title_update: "Kullanıcı Grubunu Güncelle",
    userGroup_detail_check_label: "Aktif",
    userGroup_detail_check_label_description: "Kullanıcı Gruplarının sistem durumu aktif mi?",
    userGroups_detail_Valid_Name: "Kullanıcı Grubu adı boş geçilemez",
    userGroup_list: "Kullanıcı Grupları",
    userGroup_list_breadcrumb_title: "Kullanıcı Grup Listesi",
    userGroup_list_breadcrumb_titles: "Kullanıcı Grupları Listesi",
    userGroup_list_column_status: "STATÜ",
    userGroup_list_column_name: "GRUP ADI",
    userGroup_list_add_button: "Yeni Grup",
    userGroup_list_permission_all: "Tümünü Seç",
    company_modal_check_label: "Aktif",
    company_modal_check_label_description: "Firmanın sistem durumu aktif mi?",

    project_detail_location_input_seacrh_placeholder: "Lokasyon Ara",
    company_detail_input_seacrh_placeholder: "Müşteri Ara",
    company_detail_button_remove_locations: "Müşterileri Kaldır",
    project_detail_location_button_add: "Lokasyon Ekle",
    project_detail_location_button_remove_locations: "Lokasyonları Kaldır",
    project_detail_location_button_remove_projects: "Projeleri Kaldır",
    project_detail_location_list_title: "Seçili proje için lokasyon ekle",
    project_detail_user_input_seacrh_placeholder: "Kullanıcı Ara",
    project_detail_user_button_add: "Kullanıcı Ekle",
    project_detail_user_button_remove_users: "Kullanıcıları Kaldır",
    project_detail_user_list_title: "Seçili proje için kullanıcı ekle",
    project_detail_checklist_input_seacrh_placeholder: "Kontrol Listesi Ara",
    project_detail_checklist_button_add: "Kontrol Listesi Ekle",
    project_achievementlevels_label_min_value: "Minimum Değer",
    project_achievementlevels_label_max_value: "Maksimum Değer",
    project_achievementlevels_button_add: "Başarı Seviyesi Ekle",
    project_achievementlevels_modal_create_title: "Başarı Seviyesi Ekle",
    project_achievementlevels_modal_edit_title: "Başarı Seviyesi Güncelle",
    project_achievementlevels_modal_name_label: "Başarı Seviyesi Adı",
    project_achievementlevels_modal_level_required: "Başarı seviyesi adı zorunludur",
    project_achievementlevels_modal_level_label: "Seviye Aralığı",
    Max: "Maks",
    Min: "Min",
    AchievementLevels: "Başarı Seviyeleri",
    company_detail_location_list_title: "Seçili firma için Kontrol listesi şablonu ekle",
    audit_planning_checklist_select: "Kontrol Listesi Seçiniz",
    audit_planning_checklist_name: "Kontrol Listesi",
    audit_planning_cproject_select: "Proje Seçiniz",
    audit_planning_location_select: "Lokasyon Seçiniz",
    audit_planning_location_confirmation_check: "Onay gerekli mi?",
    audit_planning_location_confirmation: "Yönetimden onay verilmesi gerekli mi?",
    audit_planning_beginDate_endDate_select: "Denetim başlangıç ve bitiş tarihi",
    audit_planning_beginDate_select: "Başlama tarihi seçiniz",
    audit_planning_endDate_select: "Bitiş tarihi seçiniz",
    audit_planning_select_lead_auditor: "Denetçi seçiniz",
    audit_planning_select_audit_type: "Denetim türü seçiniz",
    audit_planning_audit_select_assistand_auditor: "Yardımcı denetçi seçiniz",
    audit_planning_definition: "Denetim tanımını yazınız",
    audit_planning_definition_label: "Denetim Tanımı",
    audit_planning_audit: "Denetim Planlama",
    audit_planning_audit_header: "Plan bilgileri",
    audit_planning_audit_: "Plan Ayrıntıları",
    audit_planning_audit_select: "Kullanıcı Bilgileri",
    audit_planning_header: "Bitti",
    audit_planning_validation_definition: "Denetim tanımı zorunludur",
    audit_planning_validation_customer: "Müşteri adı boş geçilemez",
    audit_planning_validation_project: "Proje adı boş geçilemez",
    audit_planning_validation_location: "Lokasyon adı boş geçilemez",
    audit_planning_validation_checklist: "Kontrol Listesi boş geçilemez",
    audit_planning_validation_lead: "Baş denetçi adı boş geçilemez.",
    audit_planning_validation_user: "Yardımcı denetçi adı boş geçilemez.",
    audit_planning_validation_audit_type: "Denetim tipi boş geçilemez.",
    audit_planning_validation_beginDate: "Denetim başlangıç tarihi boş geçilemez.",
    audit_planning_validation_companyName: "Firma adı zorunludurz",
    audit_planning_validation_endDate: "Denetim bitiş tarihi boş geçilemez.",
    audit_planning_list_new: "Yeni Denetim Planı",
    audit_topbar: "Yeni Denetim",
    audit_planning_list_customer: "MÜŞTERİ ADI",
    audit_planning_list_audit_name: "DENETÇİ ADI",
    audit_planning_list_project: "PROJE ADI",
    audit_planning_list_location: "LOKASYON ADI",
    audit_planning_list_audit_type: "DENETİM TÜRÜ",
    audit_planning_list_audit_date: "DENETİM TARİHİ",
    audit_planning_list_header: "DENETİM PLANLAMA LİSTESİ",
    audit_planning_list_identification: "Denetim Planlama",
    audit_planning_list_identification_: "Denetim Planlama Listesi",
    audit_planning_list_status: "DURUM",

    project_detail_checklist_button_remove_checklists: "Kontrol Listelerini Kaldır",
    project_detail_checklist_list_title: "Seçili proje için kontrol listesi ekle",
    project_new_project_search: "Proje Ara",
    ChecklistTemplate: "Kontrol Listesi Şablonları",
    // Permissions
    PERMİSSİONS: "yetkiler",
    AccessAdminPanel: "Admin paneline erişim",
    HtmlEditorManagePictures: "Html Düzenleyici Resimleri yönet",
    ManageActivityLog: "Faaliyetler yönetimi",
    ManageCategories: "Kategorilerin yönetimi",
    ManageChecklists: "Kontrol Listesi yönetimi",
    ManageCompanies: "Firma sayfası yönetimi",
    ManageCountries: "Ülke bilgileri yönetimi",
    ManageCustomers: "Müşterilerin yönetimi",
    ManageDepartments: "Bölüm yönetimi",
    ManageEmailAccounts: "E-posta hesapları yönetimi",
    ManageFiles: "Dosyaların yönetimi",
    ManageLocations: "Lokasyonların yönetimi",
    ManageMaintenance: "Bakım Yönetimi",
    ManageMessageQueue: "Mesaj sıralamasını yönet ",
    ManageMessageTemplates: "Mesaj şablonları yönetimi",
    ManageOperationTypes: "İşlem türleri yönetimi",
    ManagePictures: "Resimlerin yönetimi",
    ManageProjects: "Projelerin yönetimi",
    ManagePushNotifications: "Anlık bildirim yönetimi",
    ManageReports: "Raporların yönetimi",
    ManageScheduleTasks: "Program görevleri yönetimi",
    ManageSystemLog: "Sistem günlüğü yönetimi",
    ManageUserAttributes: "Kullanıcı özellikleri yönetimi ",
    ManageUserGroups: "Kulllanıcı grupları yönetimi",
    ManageUsers: "Kullanıcıların yönetimi",
    ManageActions: "Aksiyonların yönetimi",
    ManageAuditPlans: "Denetim planlama yönetimi",
    ManageQuestions: "Soruların yönetimi",
    ManageAnswerTemplates: "Cevap bilgilerinin yönetimi",
    ManageAuditActions: "Denetim Aksiyonlarını Yönet",
    ManageAuditAnalysis: "Denetim Analizini Yönet",
    ManageMyCompany: "Firma Bilgilerini Yönet",
    ActionAdd: "Aksiyon Ekleme",
    ActionApproveOrReject: "Aksiyon onaylama veya reddetme",
    checklist_create_modal_h5: "Soru Listesi",
    checklist_create_modal_checkbox_label: "Bilgi Sorusu",
    checklist_create_modal_filter_input: "Soru ara",
    checklist_create_modal_select: "Kategori seç",
    checklist_create_page_title: "KONTROL LİSTESİ OLUŞTURMA SAYFASI",
    checklist_edit_page_title: "KONTROL LİSTESİ GÜNCELLEME SAYFASI",
    checklist_create_input_name: "Kontrol Listesi Adı",
    checklist_create_label_department: "Bölümler",
    checklist_create_select_department: "Bölüm seçiniz",
    checklist_create_input_signature: "İmza Bölümü",
    checklist_create_accordion_checkinfo_button: "Kontrol Listesi Bilgi Soruları",
    checklist_create_button_add_question: "Soru Ekle",
    checklist_create_button_selected_add_question: "Seçili Bölümlere Soru Ekle",
    checklist_create_button_select_all: "Hepsini Seç",
    checklist_create_accordion_button_info: "Bilgi",
    checklist_name_validation: "Kontrol listesi adı boş geçilemez",
    checklist_question_button: "Sorular",
    checklist_msg_add_question: "Soru başarıyla eklendi",
    checklist_msg_add_error_question: " daha önce eklendi",
    checklist_msg_add_question_1: " bölümüne soru eklenmemiştir!",
    checklist_create_breadcrumbs_list: "Kontrol Listeleri",
    checklist_create_breadcrumbs_new: "Yeni Kontrol Listesi",
    checklist_datatable_button_title: "Kontrol Listesini Kopyala",
    answers_template_modal_validation_template_type: "Cevap tipi boş geçilemez",
    answers_template_modal_validation_template_name: "Cevap başlığı boş geçilemez",
    answers_template_modal_label_template_checkbox: "Bu cevap şablonu, soruyu puanlama dışı bıraksın",
    answers_template_modal_select_template_pleaceholder: "Cevap tipi seçiniz",
    answers_template_modal_label_template_type: "Cevap Tipleri",
    answers_template_modal_label_template_name: "Cevap Başlığı",
    answers_template_modal_title_new: "Yeni Cevap Şablonu",
    answers_template_modal_title_edit: "Cevap Şablonu Düzenle",
    answers_template_list_button_new: "Yeni Cevap Şablonu",
    answers_template_list_title: "Cevap Şablonları",
    answers_template_list_column_title: "CEVAP ŞABLON ADI",
    answers_template_list_breadcrumbs: "Cevap Şablonları",
    answers_template_list_breadcrumbs_title: "Cevap Şablon Listesi",
    profile_photo: "Profil Fotoğrafı",

    audit_report_main_title_informations: "KÜNYE",
    audit_report_non_conformity_report: "Uygunsuzluk Raporu",
    audit_report_pdf_reportt: "Rapor PDF",
    audit_report_action_report: "Aksiyon Raporu",
    audit_report_reset_pdf_report: "PDF Raporunu Sıfırla",
    audit_report_main_title_sections: "BÖLÜMLER VE KATEGORİLER",
    audit_report_main_title_audit_detail: "DENETİM DETAY",
    audit_report_section_department: "BÖLÜM",
    audit_report_section_category: "KATEGORİ",
    audit_report_section_available_score: "BÖLÜM İÇİ ALINABİLECEK PUAN",
    audit_report_section_received_score: "BÖLÜM İÇİ ALINAN PUAN",
    audit_report_section_success_rate: "BÖLÜM İÇİ BAŞARI ORANI",
    audit_report_details_question_code: "SORU KODU",
    audit_report_details_question: "SORU",
    audit_report_details_question_score: "PUAN",
    audit_report_details_question_answer: "CEVAP",
    audit_report_details_non_conformity: "Uygunsuzluk Sebebi",
    audit_report_details_evidence: "Kanıt",
    audit_report_details_process: "İşlemler",
    audit_report_details_information_question: "Bilgi Sorusu",
    audit_report_details_information_questions: "Bilgi Soruları",
    audit_report_summary_location: "Lokasyon",
    audit_report_summary_audit_date: "Denetim Tarihi",
    audit_report_summary_appropriate_answer_count: "Tam puanlı soru sayısı",
    audit_report_summary_inappropriate_answer_count: "Tam puan olmayan soru sayısı",
    audit_report_summary_TotalEarnedScore: "Toplam Alınan Puan",
    audit_report_summary_total_available_score: "Toplam Alınabilecek Puan",
    audit_report_summary_achievement_score: "Başarı Oranı",

    audit_report_summary_achievement_level: "Başarı Durumu",
    audit_report_summary_auditer: "Denetçi",
    audit_report_delete_photo: "Fotoğrafı Sil",
    audit_report_delete_video: "Videoyu Sil",
    audit_report_category_chart: "Kategori Skor Grafiği",
    audit_report_department_chart: "Bölüm Skor Grafiği",
    audit_report_answer_distribution: "Denetim cevap Dağılımı",
    audit_report_section_not_avaliable: "Bölüm bilgisi bulunmamaktadır",
    audit_report_summary_not_avaliable: "Künye bilgisi bulunmamaktadır",
    audit_report_answer_not_avaliable: "Cevap bilgisi bulunmamaktadır",
    audit_report_detail_not_avaliable: "Detay Bilgisi bulunmamaktadır",
    audit_report_answers_title: "CEVAPLAR",

    file_picture: "İzin verilen dosyalar: jpg, jpeg. png",

    sign_in_message_password: "Şifre Hatalı",
    sign_in_message_password_error: "Hata",
    sign_in_message_password_again: "Tekrar deneyiniz",
    sign_in_message_user: "Kullanıcı bulunamadı",
    sign_in_message_user_detail: "Bilgileri kontrol ediniz",
    sign_in_message_success: "Giriş Başarılı",
    sign_in_message_success_detail: "Bilgiler doğru",
    edit_answer: "Cevap Düzenleme",
    edit_answer_open_video: "Videoyu görüntüle",
    edit_answer_open_photo: "Fotoğrafı görüntüle",
    send_approve: "Denetim Onayı",
    234: "Denetim onay bekliyor",
    audit_pending_approval: "Denetim onay bekliyor",
    audit_approve_message: "Denetimi onaylamak istediğinize emin misiniz?",
    audit_approved: "Denetim onaylandı",
    //SONRADAN EKLENEN KELİMELER
    confirm_message_location: "Lokasyonu silmek istediğinize emin misiniz?",
    confirm_message_customer: "Müşteriyi silmek istediğinize emin misiniz?",
    confirm_message_project: "Projeyi silmek istediğinize emin misiniz?",
    confirm_message_operation: "Faaliyeti silmek istediğinize emin misiniz?",
    confirm_message_user: "Kullanıcıyı istediğinizden emin misiniz?",
    confirm_message_userrole: "Kullanıcı rolünü silmek istediğinize emin misiniz?",
    confirm_message_department: "Bölümü silmek istediğinize emin misiniz?",
    confirm_message_category: "Kategoriyi silmek istediğinize emin misiniz",
    confirm_message_answer_template: "Cevap şablonunu silmek istediğinize emin misiniz?",
    confirm_message_question: "Soruyu silmek istediğinize emin misiniz?",
    confirm_message_checklist: "Kontrol listesini silmek istediğinize emin misiniz?",
    confirm_message_plan: "Denetim planını silmek istediğinize emin misiniz?",
    confirm_message_cproject: "Müşteri projesini silmek istediğinize emin misiniz?",
    confirm_message_clocation: "Müşteri lokasyonunu silmek istediğinize emin misiniz?",
    confirm_message_cuser: "Müşteri kullanıcısını silmek istediğinize emin misiniz?",
    confirm_message_img: "Fotoğrafı silmek istediğinize emin misiniz?",
    confirm_message_company: "Firmayı silmek istediğinize emin misiniz",

    confirm_message_locations: "Seçili lokasyonları silmek istediğinize emin misiniz?",
    confirm_message_customers: "Seçili müşterileri silmek istediğinize emin misiniz?",
    confirm_message_projects: "Seçili projeleri silmek istediğinize emin misiniz?",
    confirm_message_operations: "Seçili faaliyetleri silmek istediğinize emin misiniz?",
    confirm_message_users: "Seçili kullanıcıları istediğinizden emin misiniz?",
    confirm_message_userroles: "Seçili rolleri silmek istediğinize emin misiniz?",
    confirm_message_departments: "Seçili bölümleri silmek istediğinize emin misiniz?",
    confirm_message_categorys: "Seçili kategorileri silmek istediğinize emin misiniz?",
    confirm_message_answer_templates: "Seçili mesaj şablonlarını silmek istediğinize emin misiniz?",
    confirm_message_questions: "Seçili soruları silmek istediğinize emin misiniz?",
    confirm_message_checklists: "Seçili soru listelerini silmek istediğinize emin misiniz?",
    confirm_message_plans: "Seçili Planları silmek istediğinize emin misiniz?",
    confirm_message_cprojects: "Seçili projeleri silmek istediğinize emin misiniz?",
    confirm_message_clocations: "Seçili lokasyonları silmek istediğinize emin misiniz?",
    confirm_message_cusers: "Seçili kullanıcıları silmek istediğinize emin misiniz?",
    confirm_message_companies: "Seçili firmaları silmek istediğinize emin misiniz?",
    confirm_exit_page: "Değişiklikler kalıcı olarak silinecektir. Yine de çıkmak istediğinize emin misiniz?",
    confirm_profile_page: "Eski şifre yanlış",
    confirm_checklist: "Kontrol listesi zaten kullanılıyor",
    confirm_question: "Kontrol listesi kullanılıyor",
    confirm_warning: "Uyarı",

    //Profile Page
    confirm_delete_profile_image: "Profil resmin silinecek, emin misin?",
    profile_page_change_password_valid_oldpassword: "Eski şifre zorunludur",
    profile_page_breadcrumbs: "Profilim",

    //dashboard
    dashboard_audits: "Denetimler",
    dashboard_day_week_month: " Günlük, haftalık, aylık",
    dashboard_day: "Bugün",
    dashboard_week: "Bu hafta",
    dashboard_month: "Bu ay",
    dashboard_completed_audit: "Tamamlanmış Denetim",
    dashboard_card_icon_out_of_date: "Geçmiş Denetim",
    dashboard_card_icon_upcoming_audit: "Yaklaşan Denetim",
    dashboard_pending_approval: "Onay Bekleyen Denetimler",
    dashboard_pending_description: "Denetimin lokasyon ve tarih bilgisi",
    dashboard_customers_audit: "Müşteriler ve Denetimleri",
    dashboard_customers_audit_number: "Müşteriye ait denetim sayıları",
    dashboard_week_apexchart: "Haftalık",
    dashboard_month_apexchart: "Aylık",
    dashboard_year_apexchart: "Yıllık",
    dashboard_week_apexchart_title: "Haftalık denetim sayıları",
    dashboard_month_apexchart_title: "Aylık denetim sayıları",
    dashboard_year_apexchart_title: "Yıllık denetim sayıları",
    dashboard_location: "lokasyon",
    dashboard_audit: "denetim",
    dashboard_audit_number: "Denetim sayısı",
    dashboard_no_planned_audit_today: "Bugün planlanmış denetim bulunmuyor",
    dashboard_no_planned_audit_week: "Bu hafta planlanmış denetim bulunmuyor",
    dashboard_no_planned_audit_month: "Bu ay planlanmış denetim bulunmuyor",
    dashboard_loading: "Yükleniyor...",
    dasboard_approval_confirm: "Onay bekleyen denetim bulunmuyor",
    dashboard_card_customer_confirm: "Müşteri bilgisi bulunmuyor",
    dashboard_audit_score: "Denetim Puanı",
    dashboars_audit_rights: "Denetim Hakları",
    dashboard_remaining_rights_subscriptions: "Mevcut aboneliğinizden kalan haklar",
    dashboard_remaiming: "Kalan",
    dashboard_view_detail: "Detayı Gör",
    dashbord_total_rights: "Toplam Hak",
    dashboard_remaining_rights: "Kalan Hak",
    dashboard_passive: "Pasif",
    dashboard_subscription_details: "Quota Detayları",
    dashbodard_begin_date: "Başlangıç Tarihi",
    dashboard_end_date: "Bitiş Tarihi",
    dashboard_status: "Durum",

    //Analiz sayfas
    analysis: "Analiz",
    analysis_page_title: "Analiz Sayfası",
    analysis_all_customer: "Tüm müşteriler",
    analysis_all_location: "Tüm lokasyonlar",
    analysis_all_project: "Tüm projeler",
    analysis_date_input: "gg.aa.yy",
    analysis_total: "Toplam",
    analysis_number_of_audits_by_score: "Puana göre Denetim Sayısı",
    analysis_number_of_locations_by_type_of_activity: "Falliyet tipine göre lokasyon sayısı",
    analysis_type_of_activity_total: "adet faaliyet tipi vardır",
    analysis_audit_results: "Denetim Sonuçları",
    analysis_date_check_list: "Tarih/Kontrol Listesi",
    analysis_audit_result: "Denetim Sonucu",
    analysis_score: "puan",
    analysis_no_audit: "Denetim bulunmamaktadır",
    analysis_no_location_activity_type: "Faaliyet tipine sahip olan bir lokasyon bulunmamaktadır",
    analysis_project: "Proje",
    analysis_no_data_criterie: "Kriterlerinize uygun bir veri bulunamamıştır",
    analysis_operation_type_title: "Faaliyet Tipine Göre Denetim Puanı ",
    analysis_operation_type_name: "FAALİYET TİPİ",
    analysis_operation_type_audit_count: "DENETİM SAYISI",
    analysis_operation_type_score: "ORTALAMA PUAN",
    analysis_checklist_dropdown_all: "Tüm Kontrol Listeleri",
    analysis_auditor_title: "Denetçilere Ait Denetim Sayıları",
    analysis_checklist_tab_info: "Seçtiğiniz kriterlerde ",
    analysis_checklist_tab_info_after: " adet denetim bulunmaktadır",
    analysis_results: "adet denetime ait sonuçlar gösterilmektedir", //audit
    analysis_checklist_answer_distribution: "Kontrol Listesi Cevap Dağılımı",
    analysis_requiring_action: "En fazla Aksiyon Gerektiren Sorular",
    analysis_category_based_distribution: "Kategori Bazlı Dağılım",
    analysis_department_based_distribution: "Bölüm Bazlı Dağılım",
    analysis_department_score: "Sonuç Analizi",
    analysis_department_answer: "Cevap Analizi",
    analysis_department_comparison: "Karşılaştırma",
    analysis_department_comparison_subtitle: "Lokasyondaki son 2 denetime ait sonuçlar gösterilmektedir",
    analysis_answer_count: "Cevap Sayısı",
    analysis_last_ten_audits: "Son 10 Denetim Analizi",
    analysis_last_audits_pie_chart: "Pasta Grafik",
    analysis_last_audits_table: "Tablo",
    analysis_category_tab_title: "KATEGORİ",
    analysis_department_tab_title: "BÖLÜM",
    analysis_average_score: "ORTALAMA SKOR",
    analysis_first_audit: "1. Denetim",
    analysis_second_audit: "2. Denetim",
    analysis_count: "Adet",

    //answer template
    answerTemplate_state_select: "Cevap grubu",
    answerTemplate_state_select_box: "Cevap grubu seçiniz",
    Menu_Audit_Answers_State: "Cevap Grupları",
    answerTemplate_state_select_name: " Cevap grup ismi",

    //Add User Modal
    user_modal_label_user_time_zone: "Saat Dilimi",
    user_modal_select_user_time_zone: "Saat dilimi seçiniz",
    user_modal_validation_time_zone: "Saat dilimi seçimi zorunludur",

    // User Detail
    user_detail_confirm_delete_profile_image: "Profil resmi silinecek, emin misiniz?",

    // Question Comp
    question_comp_input_checkbox_type_text: "Cevap türünü metin olarak ayarla",
    question_comp_input_btn_select_template: "Şablon Seç",
    question_comp_input_btn_save_template: "Şablonu Kaydet",
    question_comp_save_template_modal_title: "Yeni Şablon",
    question_comp_save_template_modal_label_name: "Şablon Adı",
    question_comp_save_template_search: "Şablon Ara",
    question_comp_remove_template: "Şablonu kaldır",

    question_comp_save_template_modal_form_name_valid: "Şablon adı gerekli",
    question_comp_tepmlate_list_title: "Soru Şablonu Listesi",
    question_comp_tepmlate_list_confirm_delete_msg: "Seçilen şablon silinecek, emin misiniz?",
    question_comp_tepmlate_list_confirm_delete_all_msg: "Tüm şablonlar silinecek, emin misiniz?",
    delete_all: "Hepsini Sil",

    question_component_li_answer_type_DateTime: "Tarih",
    question_component_li_answer_type_Phone: "Telefon",
    question_component_li_answer_type_Signature: "İmza",
    question_component_li_answer_type_Location: "Konum",
    question_component_checkbox_required: "Cevap zorunlu",
    question_component_checkbox_required_title: "Bu seçenek, soruyu yanıtlamanın zorunlu olduğunu gösterir.",
    question_component_answer_modal_action_checkbox_label: "Aksiyon Gerekli",
    question_component_answer_modal_action_checkbox_title: "Soru için bu cevap seçilirse aksiyon alınması gerekir",
    question_component_answer_modal_evidence_checkbox_label: "Kanıt Gerekli",
    question_component_answer_modal_evidence_checkbox_title: "Soru için bu cevap seçilirse kanıt sunulması gerekir",
    question_component_answer_modal_evidence_options_title: "Kanıt gerektir",
    question_component_answer_modal_evidence_options_explication:
      "Bu cevap seçildiğinde gerekli olacak kanıtları seçin.",
    question_component_answer_modal_evidence_options_notes: "Not",
    question_component_answer_modal_evidence_options_media: "Medya",
    question_component_answer_modal_label_logic_choice: "Mantık Seçimi",
    question_component_answer_modal_na_checkbox_label: "NA",

    //Checklist Page
    checklist_page_total_number_question: "Toplam soru sayısı",
    checklist_page_number_question: "Soru sayısı",
    checklist_page_total_score: "Toplam puan",
    checklist_page_score: "Puan",
    checklist_page_info_description:
      "Kontrol listesi bilgileri bölümünü bölümlere ayırmak istiyorsanız aşağıdaki listeden istediğiniz bölümleri seçin.",
    checklist_page_info_title: "Kontrol Listesi Bilgi Bölümü",
    checklist_page_sections_description:
      "Kontrol listenizi bölümlere ayırmak istiyorsanız aşağıdaki listeden istediğiniz bölümleri seçin.",

    logo: "Logo",
    action_locaion_list_header: "Aksiyon Bilgisi Bulunan Denetimler",
    action_status_column: "AKSİYON DURUMU",
    action_approve_status: "ONAY DURUMU",
    action_date_range: "Aksiyon Tarih Aralığı",
    action_text: "Aksiyon Metni",
    action_person_change: "Lokasyonda aksiyondan sorumlu kişi",
    action_approval_status: "Onay durumu",
    no_action: "Aksiyon bulunmamaktadır",
    action_select_all_approved: "Seçimleri onayla",
    action_select_all_reject: "Seçimleri reddet",
    action_select_all_send: "Seçimleri gönder",
    action_related_questions: "İlgili soru",
    action_add_screen: "Aksiyon Ekle",
    add_action_required_date_begin: "Başlangıç tarihi zorunlu",
    add_action_required_date_end: "Bitiş tarihi zorunlu",
    add_action_required_text: "Aksiyon metni zorunlu",
    add_action_person_charge: "Sorumlu kişi ismi zorunlu",
    action_list: "Aksiyon Listesi",
    audit_detail_required_answer: "Sorunun cevaplanması zorunludur",
    action_audit_list: "Denetim Aksiyon Listesi",
    action_send_for_approve: "Girilen aksiyonu onaya göndermek istediğinizden emin misiniz?",
    action_approve_confirm_message: "Girilen aksiyonu onaylamak istediğinize emin misiniz?",
    action_reject_confirm_message: "Girilen aksiyonu reddetmek istediğinize emin misiniz?",

    // Template Pages
    template_list_page_title: "Şablon Listesi",
    template_list_name_column_title: "ŞABLON ADI",
    template_list_add_button_new_template: "Seçilen Müşteriye Şablon Ekle",
    template_list_button_new_template: "Yeni Şablon",
    menu_item_template_answers: "Şablon Cevap Anahtarları",
    menu_item_template_category: "Şablon Kategorileri",
    menu_item_template_sections: "Şablon Bölümleri",
    menu_item_template_questions: "Şablon Soruları",
    menu_item_template: "Şablonlar",
    menu_system_admin: "SİSTEM YÖNETİCİSİ",
    company_list_page_title: "Firma Listesi",
    company_new: "Yeni Firma",
    company_name: "FİRMA ADI",

    template_published_check_label_description: "Şablon sistem durumu aktif mi?",
    checklist_template_component_column_title: "ŞABLON ADI ",
    checklist_template_component_a_title: "Şablonu Kopyala",
    checklist_template_component_title: "Kontrol Listesi Şablonları",
    checklist_template_not_template: "Firmanıza ait bir şablon bulunmamaktadır",
    checklist_template_confirm_copy: "Şablonu kopyalamak istediğinize emin misiniz?",

    register_login_text: "Hesabınız Yok mu?",
    register_login_link: "Kayıt Olun",
    register_form_title: "Hesabınızı Oluşturun",
    register_form_subtitle: "Hesabınız var mı?",
    register_form_link_title: "Giriş Yapın",
    register_form_user_information: "Kullanıcı Bilgileri",
    register_form_company_information: "Firma Bilgileri",
    register_form_password_information: "Şifre Bilgileri",

    register_form_company_name: "Firma Adı",
    register_form_company_phone: "Firma Telefon",
    register_form_company_email: "Firma Mail",
    register_form_company_street_address: "Firma Açık Adres",
    register_form_company_description: "Firma Açıklaması",
    register_form_district: "İlçe",
    register_form_street_address: "Açık Adres",
    register_form_company_country: "Firma / Ülke",
    register_form_company_city: "Firma / Şehir",
    register_form_company_district: "Firma / İlçe",

    // Search Input Componentinde Kullanılan Filter Key
    locationCode: "Kod",
    cityName: "Şehir",
    countryName: "Ülke",
    locationName: "Ad",
    questionText: "Soru Cümlesi",
    code: "Soru Kodu",
    name: "Ad",
  },
};

const i18n = createI18n({
  legacy: false,
  locale: "en",
  globalInjection: true,
  messages,
});

export default i18n;
